<template>
	<div>
		<div class="content-top idm-player" id="content_top">
			<div class="wrap-content" id="wrap_content">
				<div class="main-title">ET Corporate Onboarding Video User Guide</div>
				<p class="main-second-title">This guide will show you how to create personalized videos for your corporate customers. You can view the video below or follow the on screen instructions.</p>

				
			</div>

			<div class="name-page">
			<div class="player-block">
			<div class="player-box horizontal">
				<div id="idm-player"></div>
			</div>
			</div>




				<div class="name-page__title">Video Creator Page</div>
				<div class="name-page__subtitle">Fill out the form on the video creator page with all the details you want in the video.</div>

				<div class="page-list">
					<ol>
						<li>
							<p>Client First Name - Required </p>
							<p>Please fill out your customer's first name. The spelling is important but the formatting is not as we adjust the formatting in the video automatically. </p>
							<p><span>Please note:</span> Only include your customer's first name. If you include their full name that is considered Personal Protected Information(PII).							</p>

							<img src="@/assets/img/Amex_Image01.png">
						</li>

						<li>
							<p>Program Type - Required </p>
							<p>Click the drop down and select the program you want to appear in the video.							</p>

							<img src="@/assets/img/Amex_Image02.png">
						</li>

						<li>
							<p>Business Name - Required</p>
							<p>Fill in your customer business names, make sure the spelling is correct. The formatting is not important because it will adjust automatically in the video.							</p>

							<img src="@/assets/img/Amex_Image03.png">
						</li>


						<li>
							<p>Implementation Consultant Full Name - Required</p>
							<p>Fill in your Implementation Consultant’s Full Name, make sure the spelling is correct. The formatting is not important because it will adjust automatically in the video.</p>

							<img src="@/assets/img/Amex_Image04.png">
						</li>


						<li>
							<p>Phone Number - Required</p>
							<p>Fill in the phone number for the Implementation Consultant, make sure the number is correct.</p>

							<img src="@/assets/img/Amex_Image05.png">
						</li>

						<li>
							<p>One you completed the form click the “Create Personalized Video” button</p>

						</li>
					
					</ol>
				</div>
			</div>

			<div class="name-page">
				<div class="name-page__title">Video Preview Page</div>
				<div class="name-page__subtitle">Once you create a personalized video, you will see the preview page where you can preview your video and copy the link to the customer facing version of the video.</div>
				<div class="page-list">
					<ol>
						<li>
							<p>Click on the video to play the video. Make sure everything looks good and is spelled correctly. You can click on the CTA button at the end of the video to make sure the calendar link is functioning properly.</p>

							<img src="@/assets/img/UserGuide01.webp">
						</li>

						<li>
							<p>If you have any updates, click the “Back to Video Creator” button. This will take you back to the video creation page with all your information that you submitted. You can make any adjustments and create the video again.</p>

							<img src="@/assets/img/userguide02.webp">
						</li>

						<li>
							<p>If the video looks good. Click on the “Copy Video Link for Sharing” button</p>

							<img src="@/assets/img/image10.png">
						</li>

						<li>
							<p>Paste the link you copied into your distribution method - email, SMS, ect…</p>

						</li>
					</ol>

					<p><span>Please note:</span> If you want to see the customer facing page, you can paste this link into a new browser window.</p>
				</div>
				</div>
			</div>

			
		<div class="name-page">
				<div class="name-page__title">Customer Facing Page</div>
				<p>Below is the page your customer will see from the link you copied.</p>
				<img src="@/assets/img/Amexpreview.webp">
			</div>
	</div>
</template>

<script>
export default {
  name: 'UseeGuideView',
  data:()=>{
    return {
      player_options:{
				size: "hd",
				src: window.location.protocol + '//' + window.location.hostname + require('@/assets/img/ET_Buiness_guide_mar2026.mp4'),
				autoplay: false,
				mute: false,
				idm_logo: false,
				share_button: false,
      },
    }
  },
  mounted(){
	setTimeout(()=>{
      window.idmPlayerCreate(this.player_options, "idm-player");
    }, 100);
  },
}
</script>

<style scoped>
p {
	font-size: 18px;
	padding-bottom: 15px;
	line-height: 1.4;
}
.player-block {
    justify-content: center;
	padding-bottom: 50px;
}

.wrap-content .main-second-title {
	max-width: 960px;
	margin: 15px auto 0px;
	text-align: center;
	font-size: 18px;
	padding: 0 20px;
}

.idm-lp .player-box {
	min-height: auto;
}

.name-page__subtitle {
	font-size: 20px;
	padding-bottom: 15px;

}

.name-page {
	max-width: 960px;
	margin: 15px auto 30px;
	padding: 0 20px;
}

.name-page__title {
	font-size: 25px;
	padding-bottom: 15px;
	font-weight: 500;
}

ol {
	padding-left: 20px;	
	list-style: auto;
   font-size: 18px;
	
}

ol li {
	padding-bottom: 15px;
}

p span {
	font-weight: 500;
}

.name-page img {
	max-width: 100%;
	display: block;
	margin: 0 0 15px;
}

	


</style>